import { NODE_ENV } from "@/config/config";
import { iGroup, iMiniGroup, iMiniUser } from "@/types"

export const getMiniUser = (user): iMiniUser => {
    let fullname = "";
    if(user.fullname || user.displayName){
        fullname = user ? user.fullname || user.displayName || "User" : "Anonymous User";
    } else if(user && user.personal){
        fullname = (user.personal.firstname + " " + user.personal.lastname)
    } else {
        fullname = user.user_displayName || "";
    }
    let email = "";
    email =  user && (user.user_email || user.email || user.username) ? (user.user_email || user.email || user.username) : "";
    if(user && user.personal && user.personal.email){
        email = user.personal.email;
    }
    const new_user: iMiniUser = {
        fullname : fullname,
        uid : user && user.uid ? user.uid : "",
        email : email,
        photoURL : user.photoURL || ''
    };
    return new_user
};

export const getMiniGroup = (group: iGroup): iMiniGroup => {
    const new_group: iMiniGroup = {
        id : group && group.id ? group.id : "",
        name : group && group.data && group.data.group_name ? group.data.group_name : "",
        group_parent0 : group && group.data && group.data.group_parent0 ? group.data.group_parent0 : "",
        group_parent1 : group && group.data && group.data.group_parent1 ? group.data.group_parent1 : ""
    };
    return new_group;
};

export const validName = function (name) {
    name = name.trim();
    return (
        name.length >= 2 && /^(?=.{1,50}$)[a-z]+(?:['_.\s][a-z]+)*$/i.test(name)
    );
};

export const validPhoneNo = function (phone) {
    return /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im.test(
        phone
    );
};

export const emailIsValid = function (email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const logger = {
    log : (...args) => {
        if(NODE_ENV !== 'production'){
            console.log(args);
        }
    },
    info : (...args) => {
        if(NODE_ENV !== 'production'){
            console.info(args);
        }
    },
    error : (...args) => {
        if(NODE_ENV !== 'production'){
            console.error(args);
        }
    }
}